<style>
    .modal-background {
        background-color: rgba(10, 10, 10, 0.8);
    }
    .show {
        display: flex;
    }
    .hide {
        display: none;
    }
</style>

<script>
  export let show = false;
  export let onDiscard;
  export let onAccept;
  export let title = "Confirm";
  export let message = "Are you sure?";
  export let discardLabel = "Cancel";
  export let acceptLabel = "Accept";
  
  $: modalClass = show ? 'show' : 'hide';
</script>

<div class={`modal ${modalClass}`}>
  <div class="modal-background" />
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{title}</p>
    </header>
    <section class="modal-card-body">
      {message}
    </section>
    <footer class="modal-card-foot">
      <button class="button is-success" on:click={onAccept}>{acceptLabel}</button>
      {#if onDiscard}
        <button class="button" on:click={onDiscard}>{discardLabel}</button>
      {/if}
    </footer>
  </div>
</div>
